// extracted by mini-css-extract-plugin
export default {"aboutus":"AboutusPage_aboutus__MIR5W"};